import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-calendar-programming',
    templateUrl: './calendar-programming.component.html',
    styleUrls: ['./calendar-programming.component.scss'],
    standalone: false
})
export class CalendarProgrammingComponent implements OnInit {

  @Input() data: any;

  @Input() titulo: any;
  @Input() details: any;
  @Input() startDate: any;
  @Input() hourStart: any;

  @Input() endDate: any;
  @Input() showInModal: false;


  linkGoogle: string = "https://www.google.com/calendar/render?action=TEMPLATE"
  linkICal: string = "data:text/calendar;charset=utf8,BEGIN:VCALENDAR%0AVERSION:2.0%0ABEGIN:VEVENT%0A"
  linkOutlook: string = "https://outlook.live.com/calendar/0/deeplink/compose?"

  constructor() { }

  ngOnInit() {


    this.setGoogleCalendarLink()
    this.setOutlookCalendarLink()
  }

  setGoogleCalendarLink() {

    try {
      let startDate: any
      let dateISO: any
      let date1: any

      if (this.titulo) {
        this.linkGoogle = this.linkGoogle + `&text=${this.titulo}`
      }
      if (this.details) {
        this.linkGoogle = this.linkGoogle + `&details=${this.details}`
      }
      if (this.startDate) {

        dateISO = this.setDateAndHourToISOString(this.startDate, this.hourStart)
        date1 = this.addHoursToDate(new Date(dateISO), 3)

        let date1ISO = date1.toISOString();
        let hourISO = date1ISO.substring(11, 19)

        startDate = this.setDateAndHourToString(dateISO, hourISO)

        this.linkGoogle = this.linkGoogle + `&dates=${startDate}`
        this.linkGoogle = this.linkGoogle + `%2F${startDate}`
      }
    } catch (error) {
      console.log(error)
    }

  }



  setDateAndHourToString(DateInput, HourInput) {
    let Date = DateInput.substring(0, 11).replaceAll("-", "")
    let Hour = HourInput.replaceAll(":", "") + "Z"

    return Date + Hour
  }

  setDateAndHourToISOString(DateInput, HourInput) {
    const fechaHora = DateInput + "T" + HourInput;
    const fechaLocal = new Date(fechaHora); // Esto ya considera la zona horaria local del usuario
    const fechaHoraISO = fechaLocal.toISOString();
    return fechaHoraISO;
  }

  addHoursToDate(objDate, intHours) {
    objDate.setHours(objDate.getHours() + intHours);
    return objDate;
  }

  setOutlookCalendarLink() {
    if (this.details) {
      this.linkOutlook = this.linkOutlook + `body=${this.details}`
    }
    if (this.titulo) {
      this.linkOutlook = this.linkOutlook + `&subject=${this.titulo}`
    }

    if (this.startDate) {
      let startDate = this.startDate.substring(0, 11) + this.hourStart
      this.linkOutlook = this.linkOutlook + `&startdt=${startDate}`
    }

    this.linkOutlook = this.linkOutlook + "&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent"
  }

  setICalendarLink() {

    if (this.startDate) {
      let startDate = this.startDate.substring(0, 11).replaceAll("-", "")
      let hourStart = this.hourStart.replaceAll(":", "") + "Z"

      this.linkICal = this.linkICal + `DTSTART=${startDate}${hourStart}`
    }
    if (this.titulo) {
      this.linkICal = this.linkICal + `%0ASUMMARY:${this.titulo}`
    }
    if (this.details) {
      this.linkICal = this.linkICal + `%0ADESCRIPTION:${this.details}`
    }
    this.linkICal = this.linkICal + "%0AEND:VEVENT%0AEND:VCALENDAR%0A"

  }

  openICalendar() {

    let icsMSG: string = "BEGIN:VCALENDAR%0AVERSION:2.0%0ABEGIN:VEVENT%0A"

    if (this.startDate) {
      let startDate = this.startDate.substring(0, 11).replaceAll("-", "")
      let hourStart = this.hourStart.replaceAll(":", "") + "Z"

      icsMSG = icsMSG + `DTSTART=${startDate}${hourStart}`
    }

    if (this.titulo) {
      icsMSG = icsMSG + `%0ASUMMARY:${this.titulo}`
    }

    if (this.details) {
      icsMSG = icsMSG + `%0ADESCRIPTION:${this.details}`
    }

    icsMSG = icsMSG + "%0AEND:VEVENT%0AEND:VCALENDAR%0A"

    window.open("data:text/calendar;charset=utf8," + (icsMSG));

  }

}
